import {propOr} from 'ramda';

import {ApiError} from 'shared/web';

export const is404ApiError = (error?: ApiError) => {
  const status = propOr(null, 'status', error);
  return status === 404;
};
